import { createMutationHook } from '~/shared/providers/api';

export const useCreateFreightLaneCostMutation = createMutationHook(
  'transportation.freightLaneCostCreate',
  (params: {
    freightLaneId: string;
    startDate: string;
    rateFormula: string;
    currency: string;
    endDate?: string;
    rateVariableIds?: string;
    minimumChargeAmount?: string;
    minimumChargeCurrencyCode?: string;
    chargebackFormula?: string;
    chargebackVariableIds?: string;
    minimumChargebackAmount?: string;
    minimumChargebackCurrencyCode?: string;
    fuelSurchargeFormula?: string;
    fuelSurchargeVariableIds?: string;
    fuelSurchargeMode?: string;
  }) => ({
    transportationFreightLaneCostCreate: {
      __args: {
        input: {
          freightLaneId: params.freightLaneId,
          startDate: params.startDate,
          endDate: params.endDate,
          rateFormula: params.rateFormula,
          rateVariableIds: params.rateVariableIds,
          minimumChargeAmount: params.minimumChargeAmount
            ? Number(params.minimumChargeAmount)
            : undefined,
          minimumChargeCurrencyCode: params.minimumChargeCurrencyCode,
          chargebackFormula: params.chargebackFormula,
          chargebackVariableIds: params.chargebackVariableIds,
          minimumChargebackAmount: params.minimumChargebackAmount
            ? Number(params.minimumChargebackAmount)
            : undefined,
          minimumChargebackCurrencyCode: params.minimumChargebackCurrencyCode,
          fuelSurchargeFormula: params.fuelSurchargeFormula,
          fuelSurchargeVariableIds: params.fuelSurchargeVariableIds,
          fuelSurchargeMode: params.fuelSurchargeMode,
          currency: params.currency,
        },
      },
      id: true,
      freightLaneId: true,
      startDate: true,
      endDate: true,
      rateFormula: true,
      currency: true,
      timestamps: {
        createdAt: true,
        updatedAt: true,
      },
    },
  }),
);
